/*文章创建时间格式化*/
export function formatTime(time) {
    const d = new Date(time);
    const now = Date.now();

    const diff = (now - d) / 1000;//单位为秒

    if (diff < 30)/*如果文章创建时间小于30秒*/
    {
        return "刚刚";
    } else if (diff < 3600) {
        /*向上取整*/
        return Math.ceil(diff / 60) + "分钟前";
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + "小时前";
    } else if (diff < 3600 * 24 * 2) {
        return "1天前";
    }
    return time;
}